import { render, staticRenderFns } from "./NumListForm.vue?vue&type=template&id=5df4bcaa&"
import script from "./NumListForm.vue?vue&type=script&lang=js&"
export * from "./NumListForm.vue?vue&type=script&lang=js&"
import style0 from "./NumListForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports